/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useRef, useState } from "react";

import Modal, { ModalHeader } from "../Modal";
import ContractIssueList from "./ContractIssueList";
import Contract from ".";

// Redux Store
import { useSelector } from "react-redux";
import { contractRequest, setContract } from "../../utils/contract";
import SearchEmployee from "../Employee/SearchEmployee";
import { Col, Row } from "../ContentLayout";
import Button from "../Button";
import { isEmpty } from "../../utils/lodashExtend";
import { toast } from "../../utils/toast";
import { CONTRACT_TYPE } from "../../constants/CONTRACT";
import AddContract from "./AddContract";
import { deleteEditorTemplate, getEditorTemplateList } from "../../apis/editorTemplate";
import ContractIcon from "../../assets/images/icon/contract/contract-doc-icon.svg";
import systemAlert from "../../utils/systemAlert";

const ContractRequest = () => {
  const modalEl = useRef(null);
  const [employeeSelectedList, setEmployeeSelectedList] = useState([]);
  const [selected, setSelected] = useState(null);
  const [minHeight, setMinHeight] = useState(0);
  const [isAddFormOpen, setIsAddFormOpen] = useState(false);
  const [defaultContractIssueList] = useState(CONTRACT_TYPE.filter(f =>
    !(f.type === "MONTH_SALARY_REGULAR_WORKER" ||
      f.type === "YEAR_SALARY_CONTRACT_WORKER" ||
      f.type === "MONTH_SALARY_CONTRACT_WORKER")
  ));

  const [contractIssueList, setContractIssueList] = useState(defaultContractIssueList);
  const [addMode, setAddMode] = useState("create");
  const [selectedTemplate, setSelectedTemplate] = useState(null);

  const {
    isOpen, type, target, contractIdx, mode, submit: _submit, templateIdx
  } = useSelector((store) => store.Contract);

  const reset = () => {
    setContract();
    setMinHeight(0);
    setSelected(null);
  };
  const close = (e) => {
    if (e) {
      e.preventDefault();
    }
    setContract({ isOpen: false });
    setTimeout(() => {
      reset();
    }, 500);
  };

  useEffect(() => {
    if (isOpen && modalEl && modalEl.current) {
      setTimeout(() => {
        setMinHeight(modalEl.current.offsetHeight);
      }, 500);
    }
  }, [isOpen, modalEl]);

  const submit = () => {
    if (!(selected?.type === "CONRACT_ADD")) {
      if (isEmpty(employeeSelectedList)) return toast.error("계약대상을 선택해주세요.");
      if (isEmpty(selected)) return toast.error("계약유형을 선택해주세요.");
      contractRequest(selected.type, { target: employeeSelectedList[0], templateIdx: selected?.idx });
    }
  };


  const getContract = () => {
    getEditorTemplateList({ search: { type: "contract" } })
      .then(res => {
        setContractIssueList([...defaultContractIssueList, ...(res?.data?.rows || []).map(item => {
          return {
            ...item,
            label: item.title,
            icon: ContractIcon,
            type: "customContract"
          };
        })]);
      }).catch(() => { });
  };

  useEffect(() => {
    isOpen && getContract();
  }, [isOpen]);

  const editTemplate = (template) => {
    setSelectedTemplate(template);
    setAddMode("modify");
    setIsAddFormOpen(true);

  };
  const deleteTemplate = (template) => {
    systemAlert(`[${template.title}] 양식을 삭제하시겠습니까?`, {
      buttons: [
        {
          label: "취소",
          color: "text"
        }, {
          label: "삭제",
          color: "red",
          onClick: () => {
            deleteEditorTemplate({ idx: [template.idx] })
              .then(() => {
                toast.success('삭제되었습니다.');
                getContract();
              });
          }
        }

      ]
    });
  };

  const addSubmit = () => {
    setAddMode("create");
    setIsAddFormOpen(false);
    setSelectedTemplate(null);
    getContract();
  };

  return (
    <Modal
      isOpen={isOpen}
      type={type ? "default" : "fit"}
      close={close}
      className="contract-modal"
    >
      {type ? (
        <Contract
          type={type}
          close={close}
          target={target}
          contractIdx={contractIdx}
          mode={mode}
          submit={_submit}
          templateIdx={templateIdx}
        />
      ) : (
        <div
          ref={modalEl}
          style={{
            minHeight,
          }}
        >
          <ModalHeader>새 전자계약서</ModalHeader>

          <Row>
            <Col sm={8} style={{
              borderRight: "1px solid #F1F4F8"
            }}>
              <h4>
                계약대상 선택 <span className="color-red-100">*</span>
              </h4>
              <SearchEmployee
                selectedList={employeeSelectedList}
                setSelectedList={setEmployeeSelectedList}
                isSingle={true}
              ></SearchEmployee>
            </Col>
            <Col sm={8} className="task-handover-modal-right">
              <h4>
                계약유형 선택
              </h4>
              <div className="task-handover-modal-content">
                <ContractIssueList
                  setSelected={setSelected}
                  contractIssueList={contractIssueList}
                  setIsAddFormOpen={setIsAddFormOpen}
                  customEdit={editTemplate}
                  customDelete={deleteTemplate}
                />
              </div>
            </Col>
          </Row>
          <div className="contract-modal-button-wrap">
            <Button onClick={close} color={"text"}>취소</Button>
            <Button onClick={submit}>계약서 작성</Button>
          </div>
        </div>
      )}

      {/** @todo 계약서 등록시 submit 작성하기(template call) */}
      {isAddFormOpen && (
        <AddContract
          isOpen={isAddFormOpen}
          mode={addMode}
          setMode={setAddMode}
          setIsOpen={setIsAddFormOpen}
          submit={addSubmit}
          selected={selectedTemplate}
        />
      )}
    </Modal >
  );
};

export default ContractRequest;
